
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11.995 2.197c-5.402 0-9.798 4.396-9.798 9.798 0 5.403 4.396 9.798 9.798 9.798 5.403 0 9.799-4.395 9.799-9.798 0-5.402-4.396-9.798-9.799-9.798m0 21.793C5.381 23.99 0 18.61 0 11.995 0 5.381 5.38 0 11.995 0 18.61 0 23.991 5.38 23.991 11.995c0 6.614-5.381 11.995-11.996 11.995"}}),_c('path',{attrs:{"d":"M13.379 8.812h1.404V6.737h-1.651v.007c-2 .071-2.41 1.196-2.447 2.377h-.003v1.036H9.319v2.031h1.363v5.446h2.052v-5.446h1.682l.325-2.031h-2.006V9.53c0-.4.265-.72.644-.72"}})])])
          )
        }
      }
    